// src/components/FieldValidCheck.jsx
//
// Check verde que aparece dentro do input quando o valor fica válido — braço
// `guided` do signup-ux-ab. Até aqui o cadastro só sabia dar sinal negativo
// (mensagem vermelha quando erra) e ficava mudo quando o paciente acerta.
//
// Componente compartilhado de propósito: as telas do funil não usam design
// system (cada uma carrega o próprio bloco <style> e redefine :root), então
// sem isto o check viraria cinco implementações divergentes.
//
// Uso:
//   <div className="field-wrapper">
//     <input ... />
//     <FieldValidCheck show={isValid} />
//   </div>
//   ...e uma vez por tela, dentro do <style> existente: FIELD_VALID_CHECK_CSS

import React from 'react';

export const FIELD_VALID_CHECK_CSS = `
  .field-valid-check {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    margin-right: .9rem;
    border-radius: 50%;
    background: #E8F5E9;
    color: #2E7D32;
    opacity: 0;
    transform: scale(.6);
    transition: opacity .18s ease, transform .18s cubic-bezier(.34,1.56,.64,1);
    pointer-events: none;
  }
  .field-valid-check--on {
    opacity: 1;
    transform: scale(1);
  }
  @media (prefers-reduced-motion: reduce) {
    .field-valid-check { transition: opacity .18s ease; transform: none; }
    .field-valid-check--on { transform: none; }
  }
  /* Escopado de proposito: a classe sr-only global nao existe no projeto
     (so uma copia local no PhoneForm), entao o componente carrega a propria. */
  .field-valid-check__sr {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;

/**
 * @param {boolean} show   valor do campo já é válido
 * @param {string}  label  texto para leitor de tela (ex.: "Nome válido")
 */
const FieldValidCheck = ({ show = false, label = 'Campo preenchido corretamente' }) => (
  <span
    className={`field-valid-check${show ? ' field-valid-check--on' : ''}`}
    // aria-hidden quando oculto para o leitor de tela não anunciar um estado
    // que ainda não existe; quando aparece, vira status educado (não
    // interrompe o que o paciente está digitando).
    aria-hidden={show ? undefined : 'true'}
    role={show ? 'status' : undefined}
  >
    {show ? <span className="field-valid-check__sr">{label}</span> : null}
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M3 8.5L6.2 11.7L13 4.9"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

export default FieldValidCheck;
